<template>
  <div class="category-tree" :class="{ 'root-tree': isRootLevel }">
    <div
      v-for="category in categories"
      :key="category.id"
      class="category-item"
    >
      <template v-if="categorySelectionMode === 'checkbox'">
        <div class="flex items-center gap-2">
          <UCheckbox
            :model-value="isCategorySelected(category.id)"
            @update:model-value="() => $emit('select-category', category.id)"
          />
          <span 
            class="text-sm transition-colors hover:text-primary-500"
            :class="{
              'font-medium': !hasChildren(category)
            }"
          >
            {{ category.name }}
          </span>
        </div>
      </template>
      <template v-else>
        <NuxtLink
          :to="`/katalog/${category.slug}-c${category.id}`"
          class="block text-sm transition-colors hover:text-primary-500"
          :class="{
            'font-medium': !hasChildren(category),
            'mb-2': hasChildren(category)
          }"
          active-class="text-primary-500"
        >
          {{ category.name }}
        </NuxtLink>
      </template>

      <div
        v-if="hasChildren(category)"
        class="pl-4 mt-2 border-l border-gray-200"
      >
        <FrontendCatalogCategoryTree
          :categories="Object.values(category.children)"
          :is-root-level="false"
          :category-selection-mode="categorySelectionMode"
          :is-category-selected="isCategorySelected"
          @select-category="$emit('select-category', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  categories: {
    type: Array,
    required: true,
    default: () => []
  },
  isRootLevel: {
    type: Boolean,
    default: true
  },
  categorySelectionMode: {
    type: String,
    default: 'link',
    validator: (value) => ['link', 'checkbox'].includes(value)
  },
  isCategorySelected: {
    type: Function,
    default: () => false
  }
})

defineEmits(['select-category'])

const hasChildren = (category) => {
  return category.children && Object.keys(category.children).length > 0
}
</script>

<style scoped>
.category-tree {
  @apply space-y-2;
}

.root-tree {
  @apply max-h-[300px] overflow-y-auto pr-2;
}
</style>
